// core
import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// services
import { ScriptLoaderService } from './script-loader.service';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class TrustpilotService {
  private renderer: Renderer2;
  trustpilotScriptUrl = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  initialiseAttempts: number = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    renderFactory: RendererFactory2,
    private scriptLoaderService: ScriptLoaderService
  ) {
    this.renderer = renderFactory.createRenderer(null, null);
  }

  loadTrustpilotScript() {
    if (!window.Trustpilot) {
      this.scriptLoaderService.loadJsScript(
        this.renderer,
        null,
        'text/javascript',
        this.trustpilotScriptUrl,
        'trustpilot-widget'
      ); 
    }
  }

  init(widget: any, options?: any) {
    this.loadTrustpilotScript();
    if (Array.isArray(widget)) {
      widget.forEach((selector: any) => {
        this.start(selector, options);
      });
    } else {
      this.start(widget, options);
    }
  }

  start(selector: any, options?: any) {
    setTimeout(() => {
      this.initialiseAttempts += 1;
      const element = this.document.getElementById(selector);
      if (element && window.Trustpilot) {
        element.setAttribute('data-template-id', options?.trustboxTemplate);
        element.setAttribute('data-businessunit-id', options?.businessunitId);
        window.Trustpilot.loadFromElement(element);
      } else if (this.initialiseAttempts < 20) {
        this.start(selector, options);
      }
    }, 500);
  }
}
